const CHARS = '0123456789012345678901234567890123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'

export default function createRandomString(length: number): string {
  let result = '';

  for (let ii = length; ii > 0; --ii) {
    result += CHARS[Math.floor(Math.random() * CHARS.length)];
  }

  return result;
}
